// Uploaded documents are base64-inlined into the conversation JSON that is
// posted at the end of the chat, which inflates them by roughly a third.
// The conversation budget is the raw size that still fits in the request body
// the backend accepts (25MB) once encoded, with room left for the chat itself.
const MAX_FILE_SIZE_BYTES = 7 * 1024 * 1024;
const MAX_CONVERSATION_UPLOAD_BYTES = 17 * 1024 * 1024;

export { MAX_FILE_SIZE_BYTES, MAX_CONVERSATION_UPLOAD_BYTES };
